/* ===================================================================
   ENNAKOIVA HAKU  →  assets/predictive-search.js
   Section Rendering: /search/suggest?section_id=predictive-search
   → HTML valmiina Liquidista (sections/predictive-search.liquid).
   Hakuehdotukset, osastot, tuotteet (SKU/saatavuus/ALV-hinta), sivut.
   Näppäimistö: ↑↓ liikkuu, Enter avaa valitun, Esc sulkee.
   Mallisarjat: "+N muuta mallia" -nappi avaa piilotetut rivit.
   Viimeisimmät haut: localStorage (max 6), näkyy tyhjässä tilassa.
   Debounce, AbortController, välimuisti per hakutermi.
   =================================================================== */
(function () {
  'use strict';

  var panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  var input = panel.querySelector('[data-search-input]');
  var results = panel.querySelector('[data-search-results]');
  var openers = document.querySelectorAll('[data-search-open]');
  var closers = panel.querySelectorAll('[data-search-close]');
  var body = panel.querySelector('.search-modal__body');
  var baseUrl = results.getAttribute('data-psearch-url') || '/search/suggest';

  var lastQuery = '';
  var debounceTimer = null;
  var controller = null;
  var lastFocused = null;
  var activeIndex = -1;
  var cache = {};

  // ---- Viimeisimmät haut ----
  var RECENT_KEY = 'skelte:recent-searches';
  var RECENT_MAX = 6;
  var recentBox = panel.querySelector('[data-search-recent]');
  var recentList = panel.querySelector('[data-search-recent-list]');

  function getRecent() {
    try {
      var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var a = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    a.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, RECENT_MAX))); } catch (e) {}
  }
  function renderRecent() {
    if (!recentBox || !recentList) return;
    var a = getRecent();
    recentList.innerHTML = '';
    a.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'search-modal__shortcut search-modal__recent-item';
      b.setAttribute('data-search-recent-q', q);
      b.textContent = q;
      recentList.appendChild(b);
    });
    recentBox.hidden = a.length === 0;
  }
  panel.addEventListener('click', function (e) {
    var item = e.target.closest('[data-search-recent-q]');
    if (item) {
      input.value = item.getAttribute('data-search-recent-q');
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      return;
    }
    if (e.target.closest('[data-search-recent-clear]')) {
      try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
      renderRecent();
      input.focus();
    }
  });
  var formEl = panel.querySelector('[data-search-form]');
  if (formEl) formEl.addEventListener('submit', function () { saveRecent(input.value); });

  // ---- Scroll-fade ----
  function updateFade() {
    if (!body) return;
    var maxScroll = body.scrollHeight - body.clientHeight;
    body.removeAttribute('data-at-top');
    body.removeAttribute('data-at-bottom');
    body.removeAttribute('data-no-scroll');
    if (maxScroll <= 2) { body.setAttribute('data-no-scroll', ''); return; }
    if (body.scrollTop <= 2) body.setAttribute('data-at-top', '');
    else if (body.scrollTop >= maxScroll - 2) body.setAttribute('data-at-bottom', '');
  }
  if (body) body.addEventListener('scroll', updateFade, { passive: true });

  // ---- Avaa / sulje ----
  function openPanel() {
    lastFocused = document.activeElement;
    panel.hidden = false;
    void panel.offsetWidth;
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    renderRecent();
    setTimeout(function () { input.focus(); }, 60);
    document.addEventListener('keydown', onDocKeydown);
    updateFade();
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.classList.remove('has-query');
    input.value = '';
    clearResults();
    lastQuery = '';
    document.body.style.overflow = '';
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', onDocKeydown);
    var done = function () {
      panel.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 350);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onDocKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); }
  }

  openers.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
  });
  closers.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); closePanel(); });
  });

  // ---- Näppäimistönavigointi (combobox) ----
  // Vain näkyvät (piilotetut sarjan jäsenet ohitetaan)
  function options() {
    return Array.prototype.filter.call(
      results.querySelectorAll('[data-psearch-option]'),
      function (el) { return !el.hidden; }
    );
  }

  function expandSeries(btn) {
    var gid = btn.getAttribute('data-psearch-expand');
    var rows = results.querySelectorAll('[data-psearch-series="' + gid + '"]');
    rows.forEach(function (r) { r.hidden = false; });
    var wasActive = btn.classList.contains('is-active');
    if (btn.parentNode) btn.parentNode.removeChild(btn);
    if (wasActive && rows[0]) {
      activeIndex = -1;
      setActive(options().indexOf(rows[0]));
    } else {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }
    updateFade();
  }

  results.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-psearch-expand]');
    if (btn) { e.preventDefault(); expandSeries(btn); return; }
    var link = e.target.closest('a[data-psearch-option]');
    if (link) saveRecent(input.value);
  });

  function setActive(i) {
    var opts = options();
    if (activeIndex > -1 && opts[activeIndex]) {
      opts[activeIndex].classList.remove('is-active');
      opts[activeIndex].setAttribute('aria-selected', 'false');
    }
    activeIndex = i;
    if (i < 0 || !opts[i]) {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      return;
    }
    opts[i].classList.add('is-active');
    opts[i].setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', opts[i].id);
    opts[i].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('keydown', function (e) {
    var opts = options();
    if (!opts.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(activeIndex + 1 >= opts.length ? 0 : activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(activeIndex - 1 < 0 ? opts.length - 1 : activeIndex - 1);
    } else if (e.key === 'Enter' && activeIndex > -1 && opts[activeIndex]) {
      e.preventDefault();
      var el = opts[activeIndex];
      if (el.hasAttribute('data-psearch-expand')) { expandSeries(el); return; }
      saveRecent(input.value);
      window.location.href = el.href;
    }
  });

  // ---- Osumakorostus (tuotenimi, SKU, osasto, sivu) ----
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function highlight(root, query) {
    var words = query.split(/\s+/).filter(function (w) { return w.length > 1; }).map(escapeRe);
    if (!words.length) return;
    var re = new RegExp('(' + words.join('|') + ')', 'gi');
    root.querySelectorAll('[data-psearch-hl]').forEach(function (el) {
      var text = el.textContent;
      if (!re.test(text)) return;
      re.lastIndex = 0;
      el.textContent = '';
      var last = 0, m;
      while ((m = re.exec(text)) !== null) {
        if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)));
        var mark = document.createElement('mark');
        mark.textContent = m[0];
        el.appendChild(mark);
        last = m.index + m[0].length;
      }
      if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
    });
  }

  // ---- Tulokset ----
  function clearResults() {
    results.innerHTML = '';
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
    input.setAttribute('aria-expanded', 'false');
  }

  function inject(html, query) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('[data-psearch-root]');
    if (!root) { clearResults(); return; }
    highlight(root, query);
    results.innerHTML = '';
    results.appendChild(root);
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
    input.setAttribute('aria-expanded', options().length ? 'true' : 'false');
    if (window.VAT && window.VAT.applyAll) window.VAT.applyAll(results);
    if (body) body.scrollTop = 0;
    updateFade();
  }

  function doSearch(query) {
    if (cache[query]) { inject(cache[query], query); return; }
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    panel.classList.add('is-loading');

    var url = baseUrl + '?q=' + encodeURIComponent(query) +
      '&resources[type]=query,collection,product,page' +
      '&resources[limit]=10' +   // Shopifyn maksimi per tyyppi
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&section_id=predictive-search';

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        panel.classList.remove('is-loading');
        cache[query] = html;
        if (input.value.trim() !== query) return; // vanhentunut vastaus
        inject(html, query);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        panel.classList.remove('is-loading');
        clearResults();
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length < 2) {
      if (controller) controller.abort();
      panel.classList.remove('is-loading');
      clearResults();
      lastQuery = '';
      panel.classList.remove('has-query');
      return;
    }
    panel.classList.add('has-query');
    if (q === lastQuery) return;
    lastQuery = q;
    debounceTimer = setTimeout(function () { doSearch(q); }, 200);
  });

  // Enter ilman valintaa → lomake lähtee natiivisti täydelle hakusivulle.
})();